import { render, staticRenderFns } from "./warnRule.vue?vue&type=template&id=44a674f2&scoped=true&"
import script from "./warnRule.vue?vue&type=script&lang=js&"
export * from "./warnRule.vue?vue&type=script&lang=js&"
import style0 from "./warnRule.vue?vue&type=style&index=0&id=44a674f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a674f2",
  null
  
)

export default component.exports